import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { distances, border, colors, grid } from '../../../styles/constants';
import { H2, P } from '../../../components/Typography';
import { Dl, Dt, Dd } from '../../../components/DescriptionList/Horizontal';
import { Session, Transaction } from '../../../types/checkout';
import FullAddress from './FullAddress';
import { DateTime, Money } from '../../../components/Formatters';
import Hr from '../../../components/Hr';
export interface OrderShippingOption extends WithTranslation {
    transaction: Transaction;
    session?: Session;
}

const ShippingOption = (
    {
        t,
        session,
    }: OrderShippingOption
) => {
    const shippingOption = session && session.order && session.order.shipping_option;
    return (
        <Wrapper>
            <H2>{t('payments.transaction.shipping_option')}</H2>
            <Hr />
            {!shippingOption && <P>{t('payments.transaction.no_shipping_option')}</P>}
            {session && shippingOption && (
                <>
                    <Dl>
                        <Dt doubleColumn>{t('payments.fields.shipping_option.id')}</Dt>
                        <Dd>{shippingOption.id}</Dd>
                    </Dl>
                    <Dl>
                        <Dt doubleColumn>{t('payments.fields.shipping_option.operator')}</Dt>
                        <Dd>{shippingOption.operator}</Dd>
                    </Dl>
                    {shippingOption.operator_product_id && (
                        <Dl>
                            <Dt doubleColumn>{t('payments.fields.shipping_option.operator_product_id')}</Dt>
                            <Dd>{shippingOption.operator_product_id}</Dd>
                        </Dl>
                    )}
                    <Dl>
                        <Dt doubleColumn>{t('payments.fields.shipping_option.title')}</Dt>
                        <Dd>{shippingOption.title}</Dd>
                    </Dl>

                    {shippingOption.delivery_method && (
                        <Dl>
                            <Dt doubleColumn>{t('payments.fields.shipping_option.delivery_method')}</Dt>
                            <Dd>
                                {t(
                                    `payments.fields.shipping_option.delivery_methods.${shippingOption.delivery_method}`
                                )}
                            </Dd>
                        </Dl>
                    )}
                    <Dl>
                        <Dt doubleColumn>{t('payments.fields.shipping_option.amount')}</Dt>
                        <Dd>
                            <Money amount={shippingOption.amount} currency={session.order.currency} />
                        </Dd>
                    </Dl>
                    {shippingOption.pick_up_address && (
                        <>
                            <Dl>
                                <Dt doubleColumn>{t('payments.fields.shipping_option.pick_up_address')}</Dt>
                            </Dl>
                            <Indented>
                                <FullAddress address={shippingOption.pick_up_address} />
                            </Indented>
                        </>
                    )}
                    {shippingOption.eta && (shippingOption.eta.starts_at || shippingOption.eta.ends_at) && (
                        <Dl>
                            <Dt doubleColumn>{t('payments.fields.shipping_option.eta')}</Dt>
                            <Dd>
                                {shippingOption.eta.starts_at && <DateTime isoString={shippingOption.eta.starts_at} />}
                                {shippingOption.eta.starts_at && shippingOption.eta.ends_at && ' - '}
                                {shippingOption.eta.ends_at && <DateTime isoString={shippingOption.eta.ends_at} />}
                            </Dd>
                        </Dl>
                    )}
                    {shippingOption.time_slot &&
                        (shippingOption.time_slot.starts_at || shippingOption.time_slot.ends_at) && (
                        <Dl>
                            <Dt doubleColumn>{t('payments.fields.shipping_option.time_slot')}</Dt>
                            <Dd>
                                {shippingOption.time_slot.starts_at && (
                                    <DateTime isoString={shippingOption.time_slot.starts_at} />
                                )}
                                {shippingOption.time_slot.starts_at && shippingOption.time_slot.ends_at && ' - '}
                                {shippingOption.time_slot.ends_at && (
                                    <DateTime isoString={shippingOption.time_slot.ends_at} />
                                )}
                            </Dd>
                        </Dl>
                    )}
                </>
            )}
        </Wrapper>
    );
};

export default withTranslation()(ShippingOption);

const Wrapper = styled.div`
    padding-top: ${distances.normal};
    width: 100%;
    margin-right: ${grid.gutter};
`;



const Indented = styled.div`
    width: 100%;
    border: none;
    border-left: ${border.normal} solid ${colors.borderLight};
    padding-left: ${distances.normal};
`;
